// function computePerspectiveTransform(pointsSrc, pointsDst) {
//   if (pointsSrc.length !== 4 || pointsDst.length !== 4) {
//       throw new Error("Exactly 4 points required");
//   }

//   // Create the equation matrix A such that A * h = 0
//   const A = Array(8).fill().map(() => Array(9).fill(0));

//   for (let i = 0; i < 4; i++) {
//       const [x, y] = pointsSrc[i];
//       const [u, v] = pointsDst[i];

//       // Fill matrix A
//       A[i * 2] = [-x, -y, -1, 0, 0, 0, x * u, y * u, u];
//       A[i * 2 + 1] = [0, 0, 0, -x, -y, -1, x * v, y * v, v];
//   }

//   // Solve using Gaussian elimination
//   // Convert A into row echelon form
//   for (let i = 0; i < 8; i++) {
//       // Find pivot
//       let maxRow = i;
//       for (let j = i + 1; j < 8; j++) {
//           if (Math.abs(A[j][i]) > Math.abs(A[maxRow][i])) {
//               maxRow = j;
//           }
//       }

//       // Swap maximum row with current row
//       [A[i], A[maxRow]] = [A[maxRow], A[i]];

//       // Make all rows below this one 0 in current column
//       for (let j = i + 1; j < 8; j++) {
//           const factor = A[j][i] / A[i][i];
//           for (let k = i; k < 9; k++) {
//               A[j][k] -= factor * A[i][k];
//           }
//       }
//   }

//   // Back substitution
//   const h = Array(9).fill(1); // Last element is 1
//   for (let i = 7; i >= 0; i--) {
//       let sum = 0;
//       for (let j = i + 1; j < 9; j++) {
//           sum += A[i][j] * h[j];
//       }
//       h[i] = -sum / A[i][i];
//   }

//   // Reshape into 3x3 matrix
//   return [
//       [h[0], h[1], h[2]],
//       [h[3], h[4], h[5]],
//       [h[6], h[7], h[8]]
//   ];
// }

function computePerspectiveTransform(pointsSrc, pointsDst) {
    if (pointsSrc.length < 4 || pointsDst.length < 4 || pointsSrc.length !== pointsDst.length) {
        throw new Error("At least 4 matching points required");
    }

    // Create the equation matrix A such that A * h = 0
    const A = [];
    for (let i = 0; i < pointsSrc.length; i++) {
        const [x, y] = pointsSrc[i];
        const [u, v] = pointsDst[i];
        A.push([-x, -y, -1, 0, 0, 0, x * u, y * u, u]);
        A.push([0, 0, 0, -x, -y, -1, x * v, y * v, v]);
    }

    // Convert to row echelon form with better numerical stability
    for (let i = 0; i < A.length - 1; i++) {
        // Find maximum pivot
        let maxRow = i;
        let maxVal = Math.abs(A[i][i]);

        for (let j = i + 1; j < A.length; j++) {
            const absVal = Math.abs(A[j][i]);
            if (absVal > maxVal) {
                maxVal = absVal;
                maxRow = j;
            }
        }

        // Skip if column is zero
        if (maxVal < 1e-10) continue;

        // Swap rows if necessary
        if (maxRow !== i) {
            [A[i], A[maxRow]] = [A[maxRow], A[i]];
        }

        // Eliminate column below pivot
        for (let j = i + 1; j < A.length; j++) {
            const factor = A[j][i] / A[i][i];
            for (let k = i; k < A[0].length; k++) {
                A[j][k] -= factor * A[i][k];
            }
        }
    }

    // Back substitution with h[8] = 1
    const h = Array(9).fill(0);
    h[8] = 1;  // Set last element to 1

    for (let i = A.length - 1; i >= 0; i--) {
        // Find first non-zero coefficient
        let pivotCol = -1;
        for (let j = 0; j < 8; j++) {
            if (Math.abs(A[i][j]) > 1e-10) {
                pivotCol = j;
                break;
            }
        }

        if (pivotCol === -1) continue;  // Skip if row is all zeros

        let sum = -A[i][8];  // Move constant term to right side
        for (let j = pivotCol + 1; j < 8; j++) {
            sum -= A[i][j] * h[j];
        }
        h[pivotCol] = sum / A[i][pivotCol];
    }

    // Reshape into 3x3 matrix
    const H = [
        [h[0], h[1], h[2]],
        [h[3], h[4], h[5]],
        [h[6], h[7], h[8]]
    ];

    return H;
}

// function multiplyMatrices(A, B) {
//     return A.map(row => {
//         B[0].map((_, j) =>
//             row.reduce((sum, _, k) => sum + A[row][k] * B[k][j], 0)
//         )
//     });
// }

const getBirdsEyePoints = () => {
  return [
    [0, 0], // 3p back
    [getWidth(), 0], // 2p back
    [getWidth() / 2 + 7, getHeight()], // 2p kulma
    [getWidth() / 2 - 7, getHeight()], // 3p kulma
  ]
}

const getWidth = () => {
    return 42
}

const getHeight = () => {
    return 96
}

function transformPoint(point, matrix) {
  const [x, y] = point;

  // Apply perspective transformation
  const w = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2];
  const x_new = (matrix[0][0] * x + matrix[0][1] * y + matrix[0][2]) / w;
  const y_new = (matrix[1][0] * x + matrix[1][1] * y + matrix[1][2]) / w;

//   return [(x_new / getWidth()).toFixed(6), (y_new / getHeight()).toFixed(6)]
  return [x_new, y_new]
}

function getMatrixInverse(matrix) {
    // First check if matrix is square
    if (!matrix || !isSquareMatrix(matrix)) {
        throw new Error("Must have matrix and matrix must be square to have an inverse");
    }

    const n = matrix.length;

    // Calculate determinant
    const det = calculateDeterminant(matrix);

    // Check if matrix is invertible
    if (det === 0) {
        throw new Error("Matrix is not invertible (determinant is 0)");
    }

    // For 1x1 matrix
    if (n === 1) {
        return [[1/matrix[0][0]]];
    }

    // Calculate adjugate matrix
    const adj = calculateAdjugate(matrix);

    // Calculate inverse by multiplying adjugate by 1/determinant
    const inverse = [];
    for (let i = 0; i < n; i++) {
        inverse[i] = [];
        for (let j = 0; j < n; j++) {
            inverse[i][j] = adj[i][j] / det;
        }
    }

    return inverse;
}

function isSquareMatrix(matrix) {
    const rows = matrix.length;
    return matrix.every(row => row.length === rows);
}

function calculateDeterminant(matrix) {
    const n = matrix.length;

    // Base case for 1x1 matrix
    if (n === 1) {
        return matrix[0][0];
    }

    // Base case for 2x2 matrix
    if (n === 2) {
        return matrix[0][0] * matrix[1][1] - matrix[0][1] * matrix[1][0];
    }

    let determinant = 0;
    // Expand along first row
    for (let j = 0; j < n; j++) {
        determinant += matrix[0][j] * cofactor(matrix, 0, j);
    }

    return determinant;
}

function cofactor(matrix, row, col) {
    return Math.pow(-1, row + col) * calculateDeterminant(getMinor(matrix, row, col));
}

function getMinor(matrix, row, col) {
    return matrix
        .filter((_, index) => index !== row)
        .map(row => row.filter((_, index) => index !== col));
}

function calculateAdjugate(matrix) {
    const n = matrix.length;
    const adj = Array(n).fill().map(() => Array(n).fill(0));

    for (let i = 0; i < n; i++) {
        for (let j = 0; j < n; j++) {
            adj[j][i] = cofactor(matrix, i, j);
        }
    }

    return adj;
}
// function _logMatrix(matrix, title = "Matrix", precision = 4) {
//     console.log(`\n${title}:`);

//     // Find the maximum width needed for each column
//     const colWidths = matrix[0].map((_, colIndex) => {
//         return Math.max(...matrix.map(row => {
//             const num = Number(row[colIndex]).toFixed(precision);
//             return num.length;
//         }));
//     });

//     // Create the top border
//     const border = '┌' + colWidths.map(w => '─'.repeat(w + 2)).join('┬') + '┐';
//     console.log(border);

//     // Print each row
//     matrix.forEach((row, rowIndex) => {
//         const formattedRow = row.map((val, colIndex) => {
//             const num = Number(val).toFixed(precision);
//             return num.padStart(colWidths[colIndex]);
//         });
//         console.log('│ ' + formattedRow.join(' │ ') + ' │');

//         // Add middle or bottom border
//         if (rowIndex < matrix.length - 1) {
//             console.log('├' + colWidths.map(w => '─'.repeat(w + 2)).join('┼') + '┤');
//         } else {
//             console.log('└' + colWidths.map(w => '─'.repeat(w + 2)).join('┴') + '┘');
//         }
//     });
// }

module.exports = { getMatrixInverse, transformPoint, computePerspectiveTransform, getBirdsEyePoints }